module.exports = __webpack_public_path__ + "img/vaccine-types-image-left.423ac180.png";